/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertTodoRequest} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/upsert-todo.pb'
import {UpsertTodoResponse} from '@cash-web/protos/squareup/stafftasks/managertodos/endpoints/upsert-todo.pb'


export const upsertTodo = (request: UpsertTodoRequest, options?: CashRequestOptions) => post<UpsertTodoRequest, UpsertTodoResponse>("/2.0/cash/upsert-todo", request, {...options, rejectOnError: true })